'use client'

import { faAngleUp, faAngleDown } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {ReactNode, useState} from "react"
import Button from "@/components/Button"
import {FAQProp, FAQProps} from "@/app/types/flexible-content.types";


interface SingleFAQProp {
    question: string
    children: ReactNode
}

function SingleFaq(props:SingleFAQProp) {

    const [showFaq, setShowFaq] = useState<Boolean>(false)

    return (
        <>
            <div className={`cursor-pointer border overflow-hidden rounded-lg relative p-3 lg:p-6 mb-2 last:mb-0 pl-6 lg:pl-8 ${showFaq ? "bg-[#F9F6F4] border-[#F9F6F4]" : "border-[#F1F1F1]"}`} onClick={() => setShowFaq(!showFaq)}>
                {showFaq ? null : (<div className="absolute w-[7px] left-0 top-0 bottom-0 bg-primary" />)}

                <div className={`text-lg flex items-start justify-start ${showFaq ? "text-primary font-bold" : ""}`} onClick={() => setShowFaq(!showFaq)}>
                    <span className="mr-8">{props.question}</span>
                    <span className="ml-auto">
                        <FontAwesomeIcon icon={showFaq ? faAngleUp : faAngleDown}  />
                    </span>
                </div>
                <div className={showFaq ? "block mt-4" : "hidden mt-4"}>
                    <div className="text-left">
                        {props.children}
                   </div>
                </div>
            </div>
        </>

    )
}

export default function Faqs(props: {data: FAQProps}) {

    const faqJsonLdData = props.data.FAQ.map(faq => ({
        questionName: faq.Question,
        acceptedAnswerText: faq.Answer,
    }));

    return(
        <>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(`
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    mainEntity=${faqJsonLdData}
                `) }}
            />
            <section className="py-10 xl:py-16">
                <div className="container  text-left lg:text-center">
                    {props.data.Title ? (
                    <>
                        {props.data.ShowViewAllLink ? (
                            <div className="flex items-center justify-between mb-12">
                                <h2 className="text-4xl xl:text-5xl font-bold leading-10 lg:leading-8">{props.data.Title}</h2>
                                <Button link="/help-centre" class="bg-white border border-offblack hidden md:inline-flex px-16 text-offblack" label="View all FAQs"/>
                            </div>
                        ) : (
                            <h2 className="text-4xl xl:text-5xl font-bold leading-10 lg:leading-8 mb-12">{props.data.Title}</h2>
                        )}
                    </>
                    ): null}
                    <div>
                        {props.data.FAQ.map((faq: FAQProp, index: number) => (
                            <SingleFaq key={index} question={faq.Question}>
                                {faq.Answer}
                            </SingleFaq>
                        ))}
                    </div>
                    {props.data.ShowViewAllLink && (
                        <Button link="/help-centre" class="flex lg:hidden bg-white border border-offblack mt-8  px-16 text-offblack" label="View all FAQs"/>
                    )}
                </div>
            </section>
        </>
    )
}
